import React from "react";
import URLs from "constants/urls";
import ConnectorBusiness from "../Reports/connectorBusiness";
export default function ConnectorWiseBusiness() {
  return (
    <ConnectorBusiness
      connectorWiseBusinesByDateRange={URLs.connectorWiseBusinesByDateRange}
      connectorWiseEntriesByDateRange={URLs.connectorWiseEntriesByDateRange}
    />
  );
}
